import React, { Component, PropTypes } from 'react';

let $ = window.jQuery;

export default class MultipleEmergencyContact extends Component {
	static propTypes = {
        firstname: PropTypes.string,
        lastname: PropTypes.string,
        contactNo: PropTypes.string
    };

    state = {
        firstname : '',
        lastname : '',
        contactNo : ''
    };

    componentDidMount() {
        this.setState({
            firstname: this.props.firstname,
            lastname: this.props.lastname,
            contactNo: this.props.contactNo
        });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            firstname: nextProps.firstname,
            lastname: nextProps.lastname,
            contactNo: nextProps.contactNo
        });
    }

    shouldComponentUpdate(nextProps, nextState) {
        return true;
    }

    handleOnInputFirstName = (e) => {
    	this.setState({
			firstname : e.target.value
		},() => {
			this.props.updateEmergencyArray({firstname: this.state.firstname, lastname: this.state.lastname, emergency_phones:[{contact_no: this.state.contactNo}]}, this.props.index, 'firstname');
		})
    }

    handleOnInputLastName = (e) => {
    	this.setState({
			lastname : e.target.value
		},() => {
			this.props.updateEmergencyArray({firstname: this.state.firstname, lastname: this.state.lastname, emergency_phones:[{contact_no: this.state.contactNo}]}, this.props.index, 'firstname');
		})
    }

    handleOnChangeInput = (e) => {
    	this.setState({
			contactNo : e.target.value
		},() => {
			this.props.updateEmergencyArray({firstname: this.state.firstname, lastname: this.state.lastname, emergency_phones:[{contact_no: this.state.contactNo}]}, this.props.index, 'firstname');
		})
    }

    handleClick = (e) => {
        e.preventDefault();
        let el = $(e.target);
        
        let fields = el.parents('.perContainer').find('input');
        
        // eslint-disable-next-line
        for(let i of fields) {
            
            if($(i).val().trim() === '') //validate
            {
                $(i).focus();
                return;
            }
        }
        

        this.props.addToEmergencyArray(el.hasClass('addContact'),this.props.index);        
    }

    render() {
    	var className = this.state.contactNo ? 'form-control phoneInput edited' : 'form-control phoneInput';
    	var classForFirstNames = this.state.firstname ? 'form-control edited' : 'form-control';
    	var classForLastNames = this.state.lastname ? 'form-control edited' : 'form-control';

        var buttonColor = "red removeContact"
        var buttonClassname = "fa fa-times removeContact";

        if (this.props.index === this.props.totalIndex - 1) {
            buttonColor = "blue addContact";
            buttonClassname = 'fa fa-plus addContact';
        }

        // console.log(this.state)

        return (
            <div className="row perContainer" data-index={this.props.index}>
            	<div className="col-md-4 col-xs-5 col-sm-7">
            		<div className="form-group form-md-line-input form-md-floating-label" >
            			<input type="text" className={classForFirstNames} data-index={this.props.index}
                           name={this.props.attrFirstName}
                           value={this.state.firstname} 
                           onInput={this.handleOnInputFirstName}
                           />
                        <label htmlFor={this.props.id}>First Name</label>
            		</div>
            	</div>
                <div className="col-md-4 col-xs-5 col-sm-7">
                    <div className="form-group form-md-line-input form-md-floating-label" >
                        <input type="text" className={classForLastNames} data-index={this.props.index}
                           name={this.props.attrLastName}
                           value={this.state.lastname} 
                           onChange={this.handleOnInputLastName}
                           />
                        <label htmlFor={this.props.id}>Last Name</label>
                    </div>
                </div>
                <div className="col-md-3 col-xs-5 col-sm-3">
                    <div className="form-group form-md-line-input form-md-floating-label" >
                        <input type="text" className={className} data-index={this.props.index}
                           name={this.props.numberId}
                           value={this.state.contactNo} 
                           onChange={this.handleOnChangeInput} />
                        <label htmlFor={this.props.id}>Contact No.</label>
                        <span className="help-block sr-only">Specify your country code (Optional)</span>
                    </div>
                </div>
                <div className="col-md-1 col-xs-1 col-sm-2 text-right" style={{marginTop: '20px'}}>
                    <span className="input-group-btn btn-right">
                        <a href="#" className={"btn btn-circle btn-icon-only " + buttonColor} onClick={this.handleClick}>
                            <i className={buttonClassname}></i>
                        </a>
                    </span>
                </div>
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/commons/Inputs/MultipleEmergencyContact.js
 **/